import React from 'react'
import Hangman from '../../containers/Hangman/Hangman'
import Toolbar from '../../components/UI/Toolbar/Toolbar'
import Stats from '../../containers/Stats/Stats'
import HomePage from '../../components/HomePage/HomePage'
import Aux from '../Auxiliary/Auxiliary'
import { Route, Switch } from 'react-router-dom'

const Layout = () => (
    <Aux>
      <Toolbar />
      <main className="container">
        <Switch>
          <Route path="/play" component={Hangman} />
          <Route path="/stats" component={Stats} />
          <Route path="/" exact component={HomePage} />
        </Switch>
      </main>
    </Aux>
  )

export default Layout